import { createAction, props } from "@ngrx/store";
import { masterStandingAuthTableTabName, MasterViewTypes } from "../../shared/utilities/Constants";

export const gridReady = createAction(
  '[Standing Authorizations - Master Status Table] AG Grid Ready',
  props<{ gridReady: boolean, tab: masterStandingAuthTableTabName }>()
);

export const loadViewPage = createAction(
  '[Standing Authorizations - Master Status Table] Load View Page',
  props<{ viewType: MasterViewTypes }>()
);

export const printClicked = createAction(
  '[Standing Authorizations - Master Status Table] User Requested Printout'
);
